import dynamic from 'next/dynamic';

const ServiceVehiclesGrid = dynamic(() =>
  import('./ServiceVehiclesGrid/ServiceVehiclesGrid')
);

const ServiceVehicleSubscription = dynamic(() =>
  import('./ServiceVehicleSubscription/ServiceVehicleSubscription')
);
const ServiceVehicleRequest = dynamic(() =>
  import('./ServiceVehicleRequest/ServiceVehicleRequest')
);
const SlotsGrid = dynamic(() => import('./SlotsGrid/SlotsGrid'));

const SlotsList = dynamic(() => import('./SlotsList/SlotsList'));
const ServiceVehicleFilters = dynamic(() =>
  import('./ServiceVehicleFilters/ServiceVehicleFilters')
);
const ServiceVehicleDetails = dynamic(() =>
  import('./ServiceVehicleDetails/ServiceVehicleDetails')
);
const ServiceVehicleActivity = dynamic(() =>
  import('./ServiceVehicleActivity/ServiceVehicleActivity')
);

export {
  ServiceVehiclesGrid,
  ServiceVehicleSubscription,
  ServiceVehicleRequest,
  SlotsGrid,
  SlotsList,
  ServiceVehicleFilters,
  ServiceVehicleDetails,
  ServiceVehicleActivity,
};
